<div id="content-wrapper" class="container">
	<div class="row align-items-center justify-content-center" style="height:calc(100vh - 166px);">
		<div class="col col-lg-6">

			<div class="card shadow">
				<h5 class="card-header">Jelszó módosítás</h5>
				<div class="card-body container-fluid">
					<p>Kérjük, adja meg az új jelszót.</p>
					<%- include('/ui/form', {
						params: [ 'password_reset', form_data, {
							width: 500
						} ],
						fields: [
							{ type: 'row', fields: [
								{ type: 'col', fields: [
									{
										type: 'text',
										variant: 'password',
										name: 'password',
										title: 'Jelszó',
										append: `<button type="button" class="btn btn-outline-secondary" onmousedown="$('#password_reset_password')[0].type = 'text'" onmouseup="$('#password_reset_password')[0].type = 'password'"><i class="fa fa-eye"></i></button>`,
										help: 'A választott jelszónak tartalmaznia kell <strong>kisbetűt, nagybetűt, számot</strong> és <strong>legalább 8 karakter</strong> hosszúnak kell lennie.',
										attributes: { autocomplete: 'new-password' }
									},
									{
										type: 'text',
										variant: 'password',
										name: 'password_confirm',
										title: 'Jelszó megerősítése'
									}
								]}
							]}
						]
					}) %>
				</div>
				<div class="card-footer">
					<a href="/login" class="btn btn-light"><i class="fa fa-arrow-left mr-2"></i>Vissza</a>
					<button type="button" onclick="Anvil.page.password_reset()" class="btn btn-primary float-end"><i class="fa fa-key mr-2"></i>Jelszó visszaállítása</button>
				</div>
			</div>

		</div>
	</div>
</div>

<script>
Object.assign(Anvil.page, {

	password_reset: async function () {
		Anvil.exec('auth/action_password_reset', Anvil.models.components.Form.find('#password_reset_form').data)
	}
})
</script>
